import { useState } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Checkbox,
  TextField,
  InputAdornment,
  Menu,
  withStyles
} from '@material-ui/core';
import {
  KeyboardArrowRight as ArrowRight,
  ExpandMore,
  SearchOutlined,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
  IndeterminateCheckBox as IndeterminateCheckBoxIcon
} from '@material-ui/icons';
import styles from './styles';

const TerminalSelectMenu = ({
  classes,
  anchorEl,
  onTerminalChange,
  closeTerminalMenu,
  selectedTerminalsData,
  terminalOptions = []
}) => {
  const [filteredTerminals, setFilteredTerminals] = useState(terminalOptions || []);
  const [selectedTerminals, setSelectedTerminals] = useState(selectedTerminalsData || []);
  const [regions, setRegions] = useState({});
  let isAllTerminalSelected = false;

  const setOpenRegion = (region, open = false) => {
    if (!region) {
      return;
    }
    setRegions((prevState) => ({
      ...prevState,
      [region]: open
    }));
  };

  const handleTerminalCollapse = (region) => {
    if (!region) {
      return;
    }
    setRegions((prevState) => ({
      ...prevState,
      [region]: !prevState[region]
    }));
  };

  const handleSearchTextChange = ({ target: { value } }) => {
    const searchText = value.toLowerCase();
    const openRegions = {};

    if (searchText) {
      const filteredTerminals = terminalOptions
        .map((group) => {
          const filteredData = {
            region: group.region,
            regionTerminals: group.regionTerminals.filter((terminalData) =>
              terminalData.terminalCode?.toLowerCase().includes(searchText)
            )
          };

          if (filteredData.regionTerminals.length) {
            return filteredData;
          }
          return null;
        })
        .filter(Boolean);

      filteredTerminals.forEach((group) => {
        openRegions[group.region] = true;
      });

      setFilteredTerminals(filteredTerminals);
      setRegions(openRegions);
    } else {
      terminalOptions.forEach((group) => {
        group.region === selectedTerminals[0]?.terminalRegion
          ? setOpenRegion(group.region, true)
          : setOpenRegion(group.region);
      });
      setFilteredTerminals(terminalOptions);
    }
  };

  const handleTerminalChange = (terminalCode) => {
    const updatedTerminals = [...selectedTerminals];
    const index = selectedTerminals.indexOf(terminalCode);

    if (index === -1) {
      updatedTerminals.push(terminalCode);
    } else {
      updatedTerminals.splice(index, 1);
    }
    setSelectedTerminals(updatedTerminals);
    onTerminalChange(updatedTerminals);
  };

  const handleRegionChange = (terminalGroup, isRegionSelected) => {
    const updatedTerminals = [...selectedTerminals];
    terminalGroup.regionTerminals.forEach((terminal) => {
      const index = updatedTerminals.indexOf(terminal.terminalCode);
      if (isRegionSelected) {
        if (index !== -1) {
          updatedTerminals.splice(index, 1);
        }
        return;
      }
      if (index === -1) {
        updatedTerminals.push(terminal.terminalCode);
      }
    });
    setSelectedTerminals(updatedTerminals);
    onTerminalChange(updatedTerminals);
  };

  const isAllTerminalsSelectedInRegions = (regionTerminals) => {
    return regionTerminals.every((terminal) => selectedTerminals.includes(terminal.terminalCode));
  };
  const isPartialRegionTerminalSelected = (regionTerminals) => {
    return regionTerminals.some((terminal) => selectedTerminals.includes(terminal.terminalCode));
  };

  const handleSelectAllTerminals = () => {
    const updatedTerminals = [...selectedTerminals];
    filteredTerminals.forEach((option) => {
      option.regionTerminals.forEach((terminal) => {
        const index = updatedTerminals.indexOf(terminal.terminalCode);
        if (isAllTerminalSelected) {
          if (index !== -1) {
            updatedTerminals.splice(index, 1);
          }
          return;
        }
        if (index === -1) {
          updatedTerminals.push(terminal.terminalCode);
        }
      });
    });
    setSelectedTerminals(updatedTerminals);
    onTerminalChange(updatedTerminals);
  };

  const isAllTerminalsOptionSelected = () => {
    return filteredTerminals.every((option) => {
      return option.regionTerminals.every((terminal) =>
        selectedTerminals.includes(terminal.terminalCode)
      );
    });
  };
  isAllTerminalSelected = isAllTerminalsOptionSelected();
  return (
    <Menu
      disablePortal
      getContentAnchorEl={null}
      disableAutoFocusItem
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      open
      anchorEl={anchorEl}
      onClose={closeTerminalMenu}
      MenuListProps={{ disablePadding: true }}
      classes={{
        paper: classes.terminalMenu
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <div align="center" className={classes.root}>
        <div className={classes.searchBar}>
          <TextField
            placeholder="Search"
            autoFocus
            className={classes.textField}
            onChange={handleSearchTextChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchOutlined />
                </InputAdornment>
              ),
              className: classes.inputroot,
              disableUnderline: true
            }}
          />
        </div>
        <div className={classes.list}>
          <List component="div" className={classes.selectAllRoot}>
            <ListItem key="selectAll" classes={{ root: classes.selectAllClicked }} disableGutters>
              <Checkbox
                checked={isAllTerminalSelected}
                onChange={handleSelectAllTerminals}
                className={classes.terminalCheckbox}
                color="primary"
              />
              <ListItemText
                primary="SELECT ALL"
                classes={{
                  primary: classes.label,
                  root: classes.terminalCodeListItem
                }}
              />
            </ListItem>
          </List>
          <List component="div" className={`${classes.listroot} customScroll`}>
            {filteredTerminals.length > 0 ? (
              filteredTerminals.map((group) => {
                const isRegionSelected = isAllTerminalsSelectedInRegions(group.regionTerminals);
                const isPartialTerminalSelected = isPartialRegionTerminalSelected(
                  group.regionTerminals
                );
                return (
                  <React.Fragment key={group.region}>
                    <ListItem classes={{ root: classes.terminalClicked }} disableGutters>
                      <Checkbox
                        classes={{
                          root: classes.checkBoxStyle
                        }}
                        checked={isRegionSelected}
                        onChange={() => handleRegionChange(group, isRegionSelected)}
                        color="primary"
                        indeterminate={!isRegionSelected && isPartialTerminalSelected}
                        icon={<CheckBoxOutlineBlankIcon className={classes.sizeIcon} />}
                        checkedIcon={<CheckBoxIcon className={classes.sizeIcon} />}
                        indeterminateIcon={
                          <IndeterminateCheckBoxIcon className={classes.sizeIcon} />
                        }
                      />
                      <ListItemText
                        inset
                        primary={group.region}
                        classes={{
                          root: classes.regionNameListItem,
                          primary: classes.label
                        }}
                      />
                      {group.regionTerminals.length > 0 && (
                        <ListItemIcon
                          className={classes.listItemIcon}
                          onClick={() => handleTerminalCollapse(group.region)}>
                          {regions[group.region] ? (
                            <ExpandMore color="primary" className={classes.collapseIconStyle} />
                          ) : (
                            <ArrowRight color="primary" className={classes.collapseIconStyle} />
                          )}
                        </ListItemIcon>
                      )}
                    </ListItem>
                    <Collapse in={regions[group.region]} timeout="auto" unmountOnExit>
                      <List component="div" className={classes.enablePadding} disablePadding>
                        {group.regionTerminals.map((terminalData) => (
                          <ListItem
                            key={terminalData.terminalCode}
                            classes={{ root: classes.terminalClicked }}
                            disableGutters>
                            <Checkbox
                              checked={selectedTerminals.includes(terminalData.terminalCode)}
                              onChange={() => handleTerminalChange(terminalData.terminalCode)}
                              className={classes.terminalCheckbox}
                              color="primary"
                            />
                            <ListItemText
                              primary={terminalData.terminalCode}
                              classes={{
                                primary: classes.label,
                                root: classes.terminalCodeListItem
                              }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </React.Fragment>
                );
              })
            ) : (
              <div className={classes.noOptions}>No Data Available</div>
            )}
          </List>
        </div>
      </div>
    </Menu>
  );
};

export default withStyles(styles)(TerminalSelectMenu);
